module.exports = __webpack_public_path__ + "static/media/heart-circle.d5a9deba.svg";